module.exports = __webpack_public_path__ + "media/page-about-video.49169824.mp4";